module.exports = __webpack_public_path__ + "static/img/H3G.15f96b35.png";